
import { SMAdditionalInfo } from "@/store";
import { computed, defineComponent } from "vue-demi";

import { SL_ONBOARDING, NO_SL, SL, SL_IN_PROGRESS, SL_ON_REVIEW } from "@/constants/banner";

export default defineComponent({
  name: "TableBanner",

  emits: ["ok"],

  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    okLabel: {
      type: String,
      default: "Ok",
    },
    type: {
      type: String,
      default: "sl",
    },
    tab: {
      type: String,
      default: "all",
    },
    white: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Banner: () => import("@/components/V2/Banner/Banner.vue"),
  },

  setup(props, { emit }) {
    const onOk = () => {
      emit("ok");

      SMAdditionalInfo.inviteCandidate();
    };

    const datasetNoData = computed(() => {
      return {
        [SL]: {
          title: "Let’s get started with your first visa journey",
          description:
            "Validate your first candidate by running a free Eligibility Check.\nWe’ll assess their Skilled Worker visa eligibility and help you move forward with confidence. Click ‘<b>Validate Candidate</b>’ to begin.",
          buttonLabel: "Validate Candidate",
        },
        [NO_SL]: {
          title: "Get a head start: Validate your future candidates",
          description:
            "You can already validate potential candidates you may want to sponsor once your licence is approved. This helps assess their eligibility and prepare for the visa process in advance. Click ‘<b>Validate Candidate</b>’ to begin.",
          buttonLabel: "Validate Candidate",
        },
        [SL_ONBOARDING]: {
          title: "Get a head start: Validate your future candidates",
          description:
            "You can already validate potential candidates you may want to sponsor once your account set up is completed. This helps assess their eligibility and prepare for the visa process in advance.\nClick ‘<b>Validate Candidate</b>’ to begin.",
          buttonLabel: "Validate Candidate",
        },
        [SL_IN_PROGRESS]: {
          title: "Get a head start: Validate your future candidates",
          description:
            "You can already validate potential candidates you may want to sponsor once your licence is approved. This helps assess their eligibility and prepare for the visa process in advance. Click ‘<b>Validate Candidate</b>’ to begin.",
          buttonLabel: "Validate Candidate",
        },
        [SL_ON_REVIEW]: {
          title: "Get a head start: Validate your future candidates",
          description:
            "You can already validate potential candidates you may want to sponsor once your licence is approved. This helps assess their eligibility and prepare for the visa process in advance. You can also visit the <b>Archived</b> tab to view and continue any previously saved Eligibility Checks you chose not to proceed with.",
          buttonLabel: "Validate Candidate",
        },
      };
    });

    const datasetNoActiveData = computed(() => {
      return {
        [SL]: {
          title: "Let’s get started with your next visa journey!",
          description:
            "Validate your next candidate by running a free Eligibility Check.\nWe’ll assess their Skilled Worker visa eligibility and help you move forward with confidence. You can also visit the Archived tab to view and continue any previously saved Eligibility Checks you chose not to proceed with.\nClick ‘<b>Validate Candidate</b>’ to begin.",
          buttonLabel: "Validate Candidate",
        },
        [NO_SL]: {
          title: "Get a head start: Validate your future candidates",
          description:
            "You can already validate potential candidates you may want to sponsor once your licence is approved. This helps assess their eligibility and prepare for the visa process in advance. You can also visit the <b>Archived</b> tab to view and continue any previously saved Eligibility Checks you chose not to proceed with.",
          buttonLabel: "Validate Candidate",
        },
        [SL_ONBOARDING]: {
          title: "Get a head start: Validate your future candidates",
          description:
            "You can already validate potential candidates you may want to sponsor once your licence is approved. This helps assess their eligibility and prepare for the visa process in advance. You can also visit the <b>Archived</b> tab to view and continue any previously saved Eligibility Checks you chose not to proceed with.",
          buttonLabel: "Validate Candidate",
        },
        [SL_IN_PROGRESS]: {
          title: "Get a head start: Validate your future candidates",
          description:
            "You can already validate potential candidates you may want to sponsor once your licence is approved. This helps assess their eligibility and prepare for the visa process in advance. You can also visit the <b>Archived</b> tab to view and continue any previously saved Eligibility Checks you chose not to proceed with.",
          buttonLabel: "Validate Candidate",
        },
        [SL_ON_REVIEW]: {
          title: "Get a head start: Validate your future candidates",
          description:
            "You can already validate potential candidates you may want to sponsor once your licence is approved. This helps assess their eligibility and prepare for the visa process in advance. You can also visit the <b>Archived</b> tab to view and continue any previously saved Eligibility Checks you chose not to proceed with.",
          buttonLabel: "Validate Candidate",
        },
      };
    });

    const content = computed(() => {
      if (!props.type) return null;

      if (props.tab == "all") return datasetNoData.value[props.type];

      if (props.tab == "active") return datasetNoActiveData.value[props.type];
    });

    return {
      content,
      onOk,
    };
  },
});
